<div [formGroup]="senderService.senderForm">
  <nz-form-item>
    <!--target="_blank" class="text-muted text-underline" href="https://tgstat.ru/"-->
    <nz-form-label class="text-muted mb-0">Ссылка на пост/сообщение
      <a (click)="modalService.openModal('FaqPostComponent', {});" class="text-info text-underline pointer">&nbsp;| как создать?</a>
    </nz-form-label>
    <nz-form-control [nzValidateStatus]="senderService.checkPostLinkStatus"
                     nzWarningTip="Вставьте ссылку на пост/сообщение"
                     nzErrorTip="Канал/чат должен быть открыт и иметь ссылку."
                     nzHasFeedback [nzErrorTip]="senderService.errorPostLinkDetail">
      <input nz-input formControlName="post_link" id="post_link"/>
    </nz-form-control>
  </nz-form-item>
</div>
